// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// ✅ Your Firebase configuration (from Firebase console)
const firebaseConfig = {
  apiKey: "AIzaSyC4n5crYr82nvl3fYwbgvWQAWb2m8sNqac",
  authDomain: "creatorflow-dab11.firebaseapp.com",
  projectId: "creatorflow-dab11",
  storageBucket: "creatorflow-dab11.firebasestorage.app",
  messagingSenderId: "99335422713",
  appId: "1:99335422713:web:c06f211ce97d835954d828",
  measurementId: "G-38QFZ0DYS7"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Export the things other files use
export const auth = getAuth(app);
export const db = getFirestore(app);
